"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAll = void 0;

var _validateForm = require("./validateForm");

var _validateFields = require("./validateFields");

var _mergeErrors = require("./mergeErrors");

var validateAll = function validateAll(state, fieldData, validateFunctions, getAllValues) {
  var formErrors = (0, _validateForm.validateForm)(validateFunctions, fieldData);
  var fieldErrors = (0, _validateFields.validateFields)(state, getAllValues);
  return (0, _mergeErrors.mergeErrors)(fieldErrors, formErrors);
};

exports.validateAll = validateAll;